// import {} from "lodash";
export default class RedirectLink {
    constructor(data={}) {
        this.id = data?.id || undefined;
        this.fromLink = data?.fromLink || undefined;
        this.toLink = data?.toLink || undefined;
        this.createdDate = data?.createdDate || undefined;
        this.isActive = data?.isActive || false;
    }
}